import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Container, Button, Row, Col, Spinner } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faInfo,
    faEdit,
    faTrash,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
//import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';

import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import swal from 'sweetalert';

import { withRouter } from 'react-router-dom';


const { SearchBar } = Search;

const defaultSorted = [
    {
        dataField: "idtutor",
        order: "asc",
    },
];

const mapStateToProps = (state) => {
    //console.log("Javier -------> Se carga TableComponent|MapStateToProps ");

    return {
        getReglasAutorizadasList: state.ReglasAutorizadasReducer.getReglasAutorizadasList,
        errorReglasAutorizadasList: state.ReglasAutorizadasReducer.errorReglasAutorizadasList,
    };

};

function columnFormatter(cell, row) { return (<span className="font-12">{cell}</span>); }

function headFormatter(column, colIndex) { return (<strong >{column.text}</strong>); }


const ReglasAutorizadasTabla = (props) => {
    //console.log("Javier -------> Se carga TableComponent | PROPS");


    const columns = [
        {
            dataField: "idtutor",
            text: "ID",
            sort: true,
            headerStyle: () => {
                return { width: "5%", color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "nombrecompleto",
            text: "Alumno",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "nombreservicio",
            text: "Servicio",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "concepto",
            text: "Concepto",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "valoroperacion",
            text: "Valor",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "tipooperacion",
            text: "Unidad",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },        
        
    ];


    var total = props.getReglasAutorizadasList.length;

    return (

        <Container>

            {
                props.getReglasAutorizadasList ? (
                    <ToolkitProvider
                        bootstrap4
                        keyField="idreglaautorizada"
                        data={props.getReglasAutorizadasList}
                        columns={columns}
                        defaultSorted={defaultSorted}
                        search
                    >
                        {(props) => (
                            <div>
                                <Row>
                                    <Col>
                                        <div className="float-right">
                                            <SearchBar {...props.searchProps} placeholder="Buscar En Lista .." />
                                        </div>
                                    </Col>
                                </Row>

                                <BootstrapTable
                                    className="table table-sm table-hover table-striped table-vcenter mb-0 text-nowrap"
                                    keyField="idreglaautorizada"
                                    {...props.baseProps}
                                    pagination={paginationFactory(
                                        {
                                            showTotal: true, // display pagination information
                                            sizePerPageList: [
                                                {
                                                    text: '50', value: 50
                                                },
                                                {
                                                    text: '100', value: 100
                                                },
                                                {
                                                    text: 'Todos', value: total
                                                }
                                            ],
                                            firstPageText: 'Primero', // the text of first page button
                                            prePageText: 'Previo', // the text of previous page button
                                            nextPageText: 'Siguiente', // the text of next page button
                                            lastPageText: 'Ultimo', // the text of last page button
                                            nextPageTitle: 'Ir Siguiente', // the title of next page button
                                            prePageTitle: 'Ir Previo', // the title of previous page button
                                            firstPageTitle: 'Ir Primero', // the title of first page button
                                            lastPageTitle: 'Ir Ultimo', // the title of last page button
                                        }
                                    )
                                    }
                                />
                            </div>
                        )}
                    </ToolkitProvider>
                ) :
                (
                    <div className="text-center">
                        {props.errorReglasAutorizadasList ? (
                            <h4>{props.errorReglasAutorizadasList}</h4>
                        ) : (
                                <Spinner color="dark" />
                            )}
                    </div>
                )
           }
        </Container>

    );
};

export default withRouter(connect(mapStateToProps, null)(ReglasAutorizadasTabla));

